<template>
  <div>
    <template v-if="width < 601">
      <button class="w3-button w3-red w3-right" style="margin:0 4px 8px;" @click="$emit('exit')">Exit</button>
      <div class="sectionHeader" v-if="selectedAd">
        <h5>{{selectedAd.title}}</h5>
      </div>
      <div style="margin:0 4px 8px;" class="whiteContainer">
        <div class="w3-row">
          <div class="w3-col s6">24H Total:</div>
          <div class="w3-col s6 w3-right-align">{{clicks.day}}</div>
        </div>
        <hr>
        <div class="w3-row">
          <div class="w3-col s6">Week Total:</div>
          <div class="w3-col s6 w3-right-align">{{clicks.week}}</div>
        </div>
        <hr>
        <div class="w3-row">
          <div class="w3-col s6">Month Total:</div>
          <div class="w3-col s6 w3-right-align">{{clicks.month}}</div>
        </div>
        <hr>
        <div class="w3-row">
          <div class="w3-col s6">Lifetime Total:</div>
          <div class="w3-col s6 w3-right-align">{{clicks.all}}</div>
        </div>
      </div>

      <div class="sectionHeader">
        <h5>Chart View</h5>
      </div>
      <div style="margin:0 4px;" class="whiteContainer">
        <div class="w3-row">
          <div class="w3-col s4">
            <button class="w3-button w3-block w3-margin-bottom" :class="dataView === 'pastDay' ? 'w3-green':'w3-dark-blue-grey'" @click="viewData('pastDay')">Past 24H</button>
          </div>
          <div class="w3-col s4">
            <button class="w3-button w3-block w3-margin-bottom" :class="dataView === 'pastWeek' ? 'w3-green':'w3-dark-blue-grey'" @click="viewData('pastWeek')">Past Week</button>
          </div>
          <div class="w3-col s4">
            <button class="w3-button w3-block w3-margin-bottom" :class="dataView === 'pastMonth' ? 'w3-green':'w3-dark-blue-grey'" @click="viewData('pastMonth')">Past Month</button>
          </div>
        </div>
        <!-- <button class="w3-button w3-block w3-margin-bottom" :class="dataView === 'forever' ? 'w3-green':'w3-dark-blue-grey'" @click="viewData('forever')">Forever</button> -->
      </div>

      <div class="sectionHeader">
        <h5>Analytics Chart</h5>
      </div>
      <template v-if="dataTable.day && dataTable.day.length > 1 && dataView === 'pastDay'">
        <GChart type="ColumnChart" :data="dataTable.day" :options="{height:400, colors: ['#43a047']}" style="margin:0 5px 0 4px;" />
      </template>
      <template v-if="dataView === 'pastDay' && dataTable.day && dataTable.day.length < 2">
        <div class="whiteContainer">
          <p>No Data found for this view</p>
        </div>
      </template>
      <template v-if="dataTable.week && dataTable.week.length > 1 && dataView === 'pastWeek'">
        <GChart type="ColumnChart" :data="dataTable.week" :options="{height:400, colors: ['#43a047']}" style="margin:0 5px 0 4px;" />
      </template>
      <template v-if="dataView === 'pastWeek' && dataTable.week && dataTable.week.length < 2">
        <div class="whiteContainer">
          <p>No Data found for this view</p>
        </div>
      </template>
      <template v-if="dataTable.month && dataTable.month.length > 1 && dataView === 'pastMonth'">
        <div style="padding-bottom:20px; background:#fff; margin:0 4px;">
          <GChart type="ColumnChart" :data="dataTable.month" :options="{height:400, colors: ['#43a047'], hAxis: {slantedText: true, slantedTextAngle: 60}}" style="margin:0 5px 0 4px;" />
        </div>
      </template>
      <template v-if="dataView === 'pastMonth' && dataTable.month && dataTable.month.length < 2">
        <div class="whiteContainer">
          <p>No Data found for this view</p>
        </div>
      </template>
    </template>

    <template v-if="width > 600">
      <div class="w3-row">
        <div class="w3-col s12 m8" style="margin-bottom:8px">
          <img :alt="'header image'" src="../assets/images/header2.jpg" style="width:100%; padding:0 4px 8px" />
          <button class="w3-button w3-red w3-left" style="margin:0 20px 8px 4px;" @click="$emit('exit')">Exit</button>
          <div v-if="selectedAd">
            <div class="sectionHeader">
              <h5>Ad Analytics - {{selectedAd.title}}</h5>
            </div>
            <template v-if="dataTable.day && dataTable.day.length > 1 && dataView === 'pastDay'">
              <GChart type="ColumnChart" :data="dataTable.day" :options="{height:400, colors: ['#43a047']}" style="margin:0 5px 0 4px;" />
            </template>
            <template v-if="dataView === 'pastDay' && dataTable.day && dataTable.day.length < 2">
              <div class="whiteContainer">
                <p>No Data found for this view</p>
              </div>
            </template>
            <template v-if="dataTable.week && dataTable.week.length > 1 && dataView === 'pastWeek'">
              <GChart type="ColumnChart" :data="dataTable.week" :options="{height:400, colors: ['#43a047']}" style="margin:0 5px 0 4px;" />
            </template>
            <template v-if="dataView === 'pastWeek' && dataTable.week && dataTable.week.length < 2">
              <div class="whiteContainer">
                <p>No Data found for this view</p>
              </div>
            </template>
            <template v-if="dataTable.month && dataTable.month.length > 1 && dataView === 'pastMonth'">
              <div style="padding-bottom:20px; background:#fff; margin:0 4px;">
                <GChart type="ColumnChart" :data="dataTable.month" :options="{height:400, colors: ['#43a047'], hAxis: {slantedText: true, slantedTextAngle: 60}}" style="margin:0 5px 0 4px;" />
              </div>
            </template>
            <template v-if="dataView === 'pastMonth' && dataTable.month && dataTable.month.length < 2">
              <div class="whiteContainer">
                <p>No Data found for this view</p>
              </div>
            </template>
          </div>
        </div>
        <div class="w3-col s12 m4">
          <div class="sectionHeader">
            <h5>Click Statistics</h5>
          </div>
          <div style="margin:0 4px 8px;" class="whiteContainer">
            <div class="w3-row">
              <div class="w3-col s6">24H Total:</div>
              <div class="w3-col s6 w3-right-align">{{clicks.day}}</div>
            </div>
            <hr>
            <div class="w3-row">
              <div class="w3-col s6">Week Total:</div>
              <div class="w3-col s6 w3-right-align">{{clicks.week}}</div>
            </div>
            <hr>
            <div class="w3-row">
              <div class="w3-col s6">Month Total:</div>
              <div class="w3-col s6 w3-right-align">{{clicks.month}}</div>
            </div>
            <hr>
            <div class="w3-row">
              <div class="w3-col s6">Lifetime Total:</div>
              <div class="w3-col s6 w3-right-align">{{clicks.all}}</div>
            </div>
          </div>
          <div class="sectionHeader">
            <h5>Chart View</h5>
          </div>
          <div style="margin:0 4px;" class="whiteContainer">
            <button class="w3-button w3-block w3-margin-bottom" :class="dataView === 'pastDay' ? 'w3-green':'w3-dark-blue-grey'" @click="viewData('pastDay')">Past 24H</button>
            <button class="w3-button w3-block w3-margin-bottom" :class="dataView === 'pastWeek' ? 'w3-green':'w3-dark-blue-grey'" @click="viewData('pastWeek')">Past Week</button>
            <button class="w3-button w3-block w3-margin-bottom" :class="dataView === 'pastMonth' ? 'w3-green':'w3-dark-blue-grey'" @click="viewData('pastMonth')">Past Month</button>
            <!-- <button class="w3-button w3-block w3-margin-bottom" :class="dataView === 'forever' ? 'w3-green':'w3-dark-blue-grey'" @click="viewData('forever')">Forever</button> -->
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { GChart } from 'vue-google-charts'
  import * as moment from 'moment'

  export default {
    name: 'analytics',
    data() {
      return {
        dataView: 'pastWeek',
        dataTable: [],
        width: window.innerWidth
      }
    },
    components: {
      GChart
    },
    computed: {
      clicks() {
        let clicks = {
          all: 0,
          month: 0,
          week: 0,
          day: 0,
          today: 0,
          yesterday: 0
        }
        let now = moment()
        let pastWeekDays = []
        for (let i = 0; i < 7; i++) {
          pastWeekDays.push(moment().subtract(i, 'days'))
        }
        let pastMonthDays = []
        for (let i = 0; i < 30; i++) {
          pastMonthDays.push(moment().subtract(i, 'days'))
        }
        // Data Table
        let dataTable = {
          day: [
            ['Date', 'Clicks']
          ],
          week: [],
          month: []
        }
        let weekObj = {}
        let monthObj = {}

        if (this.selectedAd) {
          if (this.selectedAd.clickData) {
            for (let click of this.selectedAd.clickData) {
              clicks.all++
              if (moment(click.created).isSame(moment().subtract(1, 'days'), 'day')) {
                clicks.yesterday++
              }
              if (moment(click.created).isSame(moment(), 'day')) {
                clicks.today++
              }
              if (moment(click.created).isBetween(moment().subtract(7, 'days'), moment())) {
                clicks.week++
              }
              if (moment(click.created).isBetween(moment().subtract(30, 'days'), moment())) {
                clicks.month++
              }
              if (moment(click.created).isBetween(moment().subtract(1, 'days'), moment())) {
                clicks.day++
              }
  
              for (let day of pastWeekDays) {
                if (moment(click.created).isSame(day, 'day')) {
                  if (weekObj[day.format()]) {
                    weekObj[day.format()].clicks = Number(weekObj[day.format()].clicks) + 1
                  } else {
                    weekObj[day.format()] = {
                      clicks: 1
                    }
                  }
                }
              }
              for (let day of pastMonthDays) {
                if (moment(click.created).isSame(day, 'day')) {
                  if (monthObj[day.format()]) {
                    monthObj[day.format()].clicks = Number(monthObj[day.format()].clicks) + 1
                  } else {
                    monthObj[day.format()] = {
                      clicks: 1
                    }
                  }
                }
              }
            }
          }
        }
        
        // week
        for (let dateItem of Object.keys(weekObj)) {
          dataTable.week.push([moment(dateItem).format('MM/DD/YYYY'), weekObj[dateItem].clicks])
        }
        dataTable.week.sort((a,b) => {
          return a[0].localeCompare(b[0])
        })
        dataTable.week.splice(0, 0, ['Date', 'Clicks'])

        // month
        for (let dateItem of Object.keys(monthObj)) {
          dataTable.month.push([moment(dateItem).format('MM/DD/YYYY'), monthObj[dateItem].clicks])
        }
        dataTable.month.sort((a,b) => {
          return a[0].localeCompare(b[0])
        })
        dataTable.month.splice(0, 0, ['Date', 'Clicks'])
        
        // day
        if (clicks.day > 0) {
          dataTable.day.push(['Past 24 Hours', clicks.day])
        }
        
        this.dataTable = dataTable

        return clicks
      },
      ...mapState([
        'selectedAd'
      ])
    },
    methods: {
      viewData(type) {
        this.dataView = type
      }
    }
  }
</script>
